import React, { useContext, useState } from "react";
import { ListGroup, Dropdown, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";

import ChatList from "./ChatList";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import { useGlobalValues } from "../../../../contexts/globalValues";
import useAuth from "../../../../hooks/useAuth";

import defultProfile from "../../../../assets/images/user/userDefault.png";
import PrinterConfig from "../../../../views/configuration/printerConfig";

const NavRight = () => {
  const configContext = useContext(ConfigContext);
  const { selectedSucursal, setSelectedSucursal } = useGlobalValues();
  const { logout, user } = useAuth();
  const { rtlLayout } = configContext.state;
  const [listOpen, setListOpen] = useState(false);
  const globalValues = JSON.parse(localStorage.getItem("globalValues"));
  const sucursales = globalValues?.sucursales;
  const [notificaciones, setNotificaciones] = useState([]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error(err);
    }
  };

  const changeSucursal = (id) => {
    const infoSuc = sucursales?.find((item) => item.id_sucursal === id);
    setSelectedSucursal({
      id_sucursal: id !== 0 ? infoSuc.id_sucursal : 0,
      sucursal: id !== 0 ? infoSuc.sucursal : "Todas",
    });
  };

  const tienda = sucursales ? sucursales[0]?.nombre : "";

  // useEffect(() => {
  //   if (!user?.userId) return;

  //   const handleConnect = () => {
  //     console.log("🟢 Socket conectado:", socket.id);
  //     console.log("user",user)
  //     socket.emit("userConnected", {
  //       id_usuario: user.userId,
  //       id_tienda: user.store,
  //       id_sucursal: user.id_sucursal,
  //     });
  //   };

  //   const handleDisconnect = () => {
  //     console.log("🔴 Socket desconectado");
  //   };

  //   const handleConnectError = (error) => {
  //     console.error("❌ Error Socket:", error.message);
  //   };

  //   const handleNotification = (notification) => {
  //     console.log("🔔 Nueva notificación:", notification);

  //     setNotificaciones((prev) => [notification, ...prev]);
  //   };

  //   socket.on("connect", handleConnect);
  //   socket.on("disconnect", handleDisconnect);
  //   socket.on("connect_error", handleConnectError);

  //   socket.on("newNotification", handleNotification);

  //   if (!socket.connected) {
  //     socket.connect();
  //   } else {
  //     handleConnect();
  //   }

  //   return () => {
  //     socket.off("connect", handleConnect);
  //     socket.off("disconnect", handleDisconnect);
  //     socket.off("connect_error", handleConnectError);
  //     socket.off("newNotification", handleNotification);

  //     socket.disconnect();
  //   };
  // }, [user?.userId, user?.store, user?.id_sucursal]);

  return (
    <React.Fragment>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto">
        <ListGroup.Item as="li" bsPrefix=" ">
          <Link>{tienda}</Link>
        </ListGroup.Item>
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown align={!rtlLayout ? "end" : "start"}>
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              id="dropdown-basic"
            >
              <i className="feather icon-map-pin icon" />
              {` ${selectedSucursal.sucursal}`}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <PerfectScrollbar>
                {sucursales?.length > 1 ? (
                  <Dropdown.Item key={0} onClick={() => changeSucursal(0)}>
                    <b>{"Todas"}</b>
                  </Dropdown.Item>
                ) : null}
                {sucursales?.map((item) => (
                  <Dropdown.Item
                    key={item.id_sucursal}
                    onClick={() => changeSucursal(item.id_sucursal)}
                  >
                    <b>{item.sucursal}</b>
                  </Dropdown.Item>
                ))}
              </PerfectScrollbar>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
        <ListGroup.Item as="li" bsPrefix=" ">
          {/* <Select
            options={["Principal", "Sucursal 1"]}
            value={0}
          /> */}
          <Dropdown align={!rtlLayout ? "end" : "start"}>
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              id="dropdown-basic"
            >
              <i className="feather icon-printer icon" />
            </Dropdown.Toggle>
            <Dropdown.Menu
              align="end"
              className="notification notification-scroll"
            >
              <div className="noti-head">
                <h6 className="d-inline-block m-b-0">
                  Configuracion impresoras
                </h6>
                <div className="float-right"></div>
              </div>
              <PerfectScrollbar>
                <ListGroup
                  as="ul"
                  bsPrefix=" "
                  variant="flush"
                  className="noti-body"
                >
                  <ListGroup.Item as="li" bsPrefix=" " className="notification">
                    <PrinterConfig />
                  </ListGroup.Item>
                </ListGroup>
              </PerfectScrollbar>
              <div className="noti-footer">
                <Link to="/config/printer">Ir a Configuracion</Link>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
        {user?.role === "Administrador" ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            {/* <Select
            options={["Principal", "Sucursal 1"]}
            value={0}
          /> */}
            <Dropdown align={!rtlLayout ? "end" : "start"}>
              <Dropdown.Toggle
                as={Link}
                variant="link"
                to="#"
                id="dropdown-basic"
              >
                <i className="feather icon-bell icon" />
                {/* {notificaciones.length > 0 ? (
                  <span className="badge rounded-pill bg-danger">
                    <span />
                  </span>
                ) : (
                  ""
                )} */}
              </Dropdown.Toggle>
              <Dropdown.Menu
                align="end"
                className="notification notification-scroll"
              >
                <div className="noti-head">
                  <h6 className="d-inline-block m-b-0">Notifications</h6>
                  <div className="float-right">
                    <Link to="#" className="m-r-10">
                      mark as read
                    </Link>
                    <Link to="#">clear all</Link>
                  </div>
                </div>
                <PerfectScrollbar>
                  <ListGroup
                    as="ul"
                    bsPrefix=" "
                    variant="flush"
                    className="noti-body"
                  >
                    <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                      <p className="m-b-0">NEW</p>
                    </ListGroup.Item>
                    {notificaciones.map((noti) => (
                      <ListGroup.Item
                        as="li"
                        bsPrefix=" "
                        className="notification"
                      >
                        <Card>
                          <img
                            className="img-radius"
                            src={user ? user.image : defultProfile}
                            alt="Generic placeholder"
                          />
                          <Card.Body>
                            <p>
                              <strong>{noti.titulo}</strong>
                              <span className="n-time text-muted">
                                <i className="icon feather icon-clock m-r-10" />
                                {noti.fecha_creacion}
                              </span>
                            </p>
                            <br></br>
                            <p>{noti.mensaje}</p>
                          </Card.Body>
                        </Card>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </PerfectScrollbar>
                <div className="noti-footer">
                  <Link to="#">show all</Link>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </ListGroup.Item>
        ) : (
          ""
        )}

        {user?.role === "superUser" ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <Dropdown>
              <Dropdown.Toggle
                as={Link}
                variant="link"
                to="#"
                className="displayChatbox"
                onClick={() => setListOpen(true)}
              >
                <i className="icon feather icon-mail" />
                <span className="badge bg-success">
                  <span />
                </span>
              </Dropdown.Toggle>
            </Dropdown>
          </ListGroup.Item>
        ) : (
          ""
        )}
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown align={!rtlLayout ? "end" : "start"} className="drp-user">
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              id="dropdown-basic"
            >
              <img
                src={user?.image || defultProfile}
                className="img-radius wid-40"
                alt="Img"
              />
            </Dropdown.Toggle>
            <Dropdown.Menu align="end" className="profile-notification">
              <div
                className="pro-head"
                style={{ display: "flex", alignItems: "center" }}
              >
                <img
                  src={user?.image || defultProfile}
                  className="img-radius"
                  alt="Img"
                />
                <div
                  className="user-info"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <b>{!user ? "" : user.name}</b>
                  <span className="user-role">{!user ? "" : user.role}</span>
                </div>
                <Link to="#" className="dud-logout" title="Logout">
                  <i className="feather icon-log-out" />
                </Link>
              </div>
              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="pro-body"
              >
                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="/config/profile-view" className="dropdown-item">
                    <i className="feather icon-user" /> Perfíl
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="#" className="dropdown-item">
                    <i className="feather icon-mail" /> Mis mensajes
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="#" className="dropdown-item" onClick={handleLogout}>
                    <i className="feather icon-log-out" /> Cerrar sesión
                  </Link>
                </ListGroup.Item>
              </ListGroup>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
      <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
    </React.Fragment>
  );
};

export default NavRight;
